export default __webpack_public_path__ + "static/bgm-44e8b161efce04d53617636b33c31835.mp4";